// @ts-strict-ignore
import { addMethod, string } from "yup";

import { addMethod as addMethodLegacy, string as stringLegacy } from "@braze/yup-legacy";

import templatableUtil from "@lib/liquid/templatableUtil";

addMethodLegacy(stringLegacy, "maxLengthIgnoringLiquid", function (limit, message) {
  return this.test({
    name: "maxLengthIgnoringLiquid",
    exclusive: true,
    message,
    params: { limit },
    test(value) {
      const withoutLiquid = templatableUtil.lengthExcludingLiquid(value);
      return !value || withoutLiquid !== value.length || value.length <= limit;
    },
  });
});

addMethod(string, "maxLengthIgnoringLiquid", function (limit, message) {
  return this.test({
    name: "maxLengthIgnoringLiquid",
    exclusive: true,
    message,
    params: { limit },
    test(value) {
      const withoutLiquid = templatableUtil.lengthExcludingLiquid(value);
      return !value || withoutLiquid !== value.length || value.length <= limit;
    },
  });
});

declare module "@braze/yup-legacy" {
  interface StringSchema {
    maxLengthIgnoringLiquid(length: number, message: string): this;
  }
}

declare module "yup" {
  interface StringSchema {
    maxLengthIgnoringLiquid(length: number, message: string): this;
  }
}
